module.exports = __webpack_public_path__ + "img/HE7302-112.c45d2408.jpg";